import { Directive, ElementRef, AfterContentInit } from '@angular/core';

@Directive({
  selector: 'input[appAutoFocus]'
})
export class AutofocusDirective implements AfterContentInit {

  constructor(
    private el: ElementRef<HTMLInputElement>
  ) { }

  ngAfterContentInit() {
    // Note: focus if hover supported (i.e., prevents auto keyboard popup on touch only devices)
    const isHoverSupported = window.matchMedia( '(hover: hover)' ).matches;

    if (isHoverSupported) {
      setTimeout(() => {
        this.el.nativeElement.focus();
      }, 0);
    }
  }
}
